import { useMemo } from "react";
import { DataGridTypes } from "devextreme-react/cjs/data-grid";

import { DateTimeFormatStrings } from "@/shared/enums";
import { CustomerModel } from "@/shared/models/Customer";
import { DxDataGridColumn } from "@/shared/models/DxDataGridColumn";
import { Utilities } from "@/shared/utils/utilities";

const GenerateCellValue = (currentValue: any, currentModel: CustomerModel, columnItem: DxDataGridColumn) => {
  if (columnItem.dataField === "IncludeInNewSurchargeEvents") {
    return currentValue ? "Yes" : "No";
  }

  if (columnItem.dataField === "SurchargeStartDate") {
    return currentValue ? Utilities.formatDate(currentValue, DateTimeFormatStrings.FORMAT_13) : "";
  }

  if (columnItem.dataField.startsWith("DeterminantsProps")) {
    var detail = currentModel.DeterminantsProps[columnItem.cellRenderCaption!];
    let value = detail && detail.IsNumeric ? detail.NumericValue : detail.StringValue;

    if (!detail.IsNumeric && columnItem.cellRenderCaption === "NOLA Tax") {
      return value === "yes" ? "Yes" : value === "no" ? "No" : value;
    }

    return value ? value.toString() : "";
  }

  return currentValue;
};

export const DataGridCustomizeCell = (columnCellTemplateData: DataGridTypes.ColumnCellTemplateData, columnItem: DxDataGridColumn) => {
  const cellValue = useMemo(
    () => GenerateCellValue(columnCellTemplateData.value, columnCellTemplateData.data, columnItem),
    [columnCellTemplateData, columnItem]
  );
  return <div className="cursor-point">{cellValue}</div>;
};

export const DataGridCustomizeCellFilter = (filterValue: any, selectedFilterOperation: string, columnItem: DxDataGridColumn) => {
  if (columnItem.dataField.startsWith("DeterminantsProps")) {
    // For determinants props, we need to filter on the nested property
    return [
      (data: CustomerModel) => {
        const detail = data.DeterminantsProps[columnItem.cellRenderCaption!];
        if (!detail) return "";
        const value = detail.IsNumeric ? detail.NumericValue : detail.StringValue;
        return value ? value.toString() : "";
      },
      selectedFilterOperation || "contains",
      filterValue,
    ];
  }

  return [columnItem.dataField, selectedFilterOperation || "contains", filterValue];
};

export const DataGridCustomizeCellSort = (data: CustomerModel, columnItem: DxDataGridColumn) => {
  if (columnItem.dataField === "Update") {
    return data.Update;
  }

  return GenerateCellValue((data as any)[columnItem.dataField], data, columnItem);
};
